// extracted by mini-css-extract-plugin
export default {"lockIcon":"collector-details_lockIcon__dd319","container":"collector-details_container__614c9","dayPicker":"collector-details_dayPicker__b9d07"};